import moment from 'moment';

function DateField({ timeMillis = 0 }) {
    return timeMillis ? (
        <span>{moment(timeMillis).format('ll [@] LT')}</span>
    ) : null;
}

export default DateField;
